// extracted by mini-css-extract-plugin
var _1 = "webpack-components-FileUploadDialog-components-DropZone-module__container";
var _2 = "webpack-components-FileUploadDialog-components-DropZone-module__icon";
var _3 = "webpack-components-FileUploadDialog-components-DropZone-module__instructions";
var _4 = "webpack-components-FileUploadDialog-components-DropZone-module__overlay";
export { _1 as "container", _2 as "icon", _3 as "instructions", _4 as "overlay" }
